import React from 'react';
import { Invoices } from './Invoices';

/**
 * Admin-only page: all bill-creation forms live here.
 * Renders the shared Invoices component in `prepare` mode which shows the
 * Billing Policy + all 5 bill-creation cards (Maintenance, Water, Common
 * Water, Common Electricity, Additional Common Work) and nothing else.
 */
const PrepareBills = () => <Invoices view="prepare" />;
export default PrepareBills;
export { PrepareBills };
